import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';
import { ProfileUserModel } from './../../models/authentication/profile-user.model';

@Injectable({
  providedIn: 'root'
})
export class ProfileUserService {
  constructor(private _httpClient: HttpClient) { }

  exportConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.profileUser.ExportConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getColumnsForConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.profileUser.GetColumnsAsync}`);
  }

  getProfileUsersForConsultation(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.profileUser.GetProfileUsersForConsultation}`,
      filters, { params: params }
    );
  }

  createProfileUser(profileUserModel: ProfileUserModel): Observable<ProfileUserModel> {
    return this._httpClient.post<ProfileUserModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.profileUser.CreateProfileUser}`,
      profileUserModel);
  }

  updateProfileUser(profileUserModel: ProfileUserModel): Observable<ProfileUserModel> {
    return this._httpClient.put<ProfileUserModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.profileUser.UpdateProfileUser}`,
      profileUserModel);
  }

  deleteProfileUser(profileUserId: number): Observable<ProfileUserModel> {
    return this._httpClient.delete<ProfileUserModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.profileUser.DeleteProfileUser}/${profileUserId}`);
  }

  getProfileUserById(profileUserId: number | null): Observable<ProfileUserModel> {
    return this._httpClient.get<ProfileUserModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.profileUser.GetProfileUserById}/${profileUserId}`)
  }
  getProfileUserByCode(code: number): Observable<ProfileUserModel> {
    return this._httpClient.get<ProfileUserModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.profileUser.GetProfileUserByCode}/${code}`)
  }
}